module.exports = __webpack_public_path__ + "static/media/38.ed26c1ab.jpg";